import { BasicClient } from '@/utils/httpClient';

export default class UserManagement {
    client: BasicClient;
    constructor() {
        this.client = new BasicClient();
    }
    modifyUser(userId: number,formUser: any) {
        let params = {
            usuario: formUser.usuario,
            nombre: formUser.nombre,
            apellido: formUser.apellido,
            mail: formUser.mail,
            dni: formUser.dni,
            cuil: formUser.cuil,
            fecha_nacimiento: formUser.fecha_nacimiento_format,
            fecha_contratacion: formUser.fecha_contratacion_format,
            numero_legajo: formUser.numero_legajo
        };
        return this.client.exec(`/v2/admin-mod/users/${userId}`, 'PUT', params);
    }
    getRules(userId: number){
        return this.client.exec(`/v2/admin-mod/users/model_rules/forupdate/${userId}`, 'GET');
    }
    getProfileCompany(idempresa: number, params: object) {
        return this.client.exec(`/v2/admin-mod/profile/company/${idempresa}`, 'GET', params);
    }
    setSectionLocation(userId: number, sector: string, locacion: string) {
        let params = {
            sector: sector,
            locacion: locacion,
        }
        return this.client.exec(`/v2/admin-mod/users/${userId}/sectorandlocation`, 'PUT', params);
    }
    setPositionReport(userId: number, cargo: string, reporta: number) {
        let params = {
            cargo: cargo,
            reporta: reporta,
        }
        return this.client.exec(`/v2/admin-mod/users/${userId}/positionandreport`, 'PUT', params);
    }
    getProfilesUser(idusuario: number) {
        return this.client.exec(`/v2/admin-mod/profile/users/${idusuario}`, 'GET');
    }
    putProfilesUser(idusuario: number, profiles: string) {
        let params = {
            idperfiles: profiles
        }
        return this.client.exec(`/v2/admin-mod/profile/users/${idusuario}`, 'PUT', params);
    }
    putFiltersUser(idusuario: number, filters: any) {
        let params = {
            filtros: filters
        }
        return this.client.exec(`/v2/admin-mod/users/${idusuario}/filtrosectorlocacion`, 'PUT', params);
    }
    getPolicies(){
        return this.client.exec(`/v2/licenses/policies`, 'GET');
    }
    getUserLicences(idusuario: number){
        return this.client.exec(`/v2/admin-mod/users/licensesprofile/${idusuario}`, 'GET');
    }
    putUserLicences(idusuario: number, tienePerfilLicencias: boolean, tienePerfilAprobador: boolean, nivelesAprobacion: number, numeroLegajoAprobador: number, idPolitica: number, antiguedad: number, tieneLicenciaProg: boolean, fechaInicioProg: string, idUsuarioAprobador: number) {
        let params = {}
        if (tienePerfilLicencias == true) {
            params = {
                tiene_perfil_licencias: tienePerfilLicencias,
                tiene_perfil_aprobador: tienePerfilAprobador,
                niveles_aprobacion: nivelesAprobacion,
                numero_legajo_aprobador: numeroLegajoAprobador,
                id_politica: idPolitica,
                antiguedad_previa: antiguedad,
                licencias_progresivas: tieneLicenciaProg,
                fecha_inicio_licencias_progresivas: fechaInicioProg,
                id_usuario_aprobador: idUsuarioAprobador
            }
        }
        if(tienePerfilLicencias == false){
            params = {
                tiene_perfil_licencias: tienePerfilLicencias,
                tiene_perfil_aprobador: tienePerfilAprobador,
            }
        }
        return this.client.exec(`/v2/admin-mod/users/licensesprofile/${idusuario}`, 'PUT', params);
    }
    approverLicense() {
        return this.client.exec(`/v2/admin-mod/users/approver`, 'GET');
    }
    changeUserMail(idusuario:number,mail:string){
        let params = {
            mail: mail
        }
        return this.client.exec(`/v2/admin-mod/users/${idusuario}/changeUserMail`, 'PUT', params);
    }

    putReactivateUser(idUser: number, recruitmentDate: string, email = false, organizationModel:false) {
        let params = {
            idusuario: idUser,
            fecha_contratacion: recruitmentDate,
            mail: email,
            organizationModel: organizationModel
        };
        if (!params.organizationModel) {
            delete params.organizationModel
        }
        return this.client.exec(`/v2/admin-mod/users/${idUser}/ReactivateEmployee`, 'PUT', params)
    }
    searchActiveUsers(params) {
        return this.client.exec(`/v2/admin-mod/users/searchactive`, 'GET', params);
    }
    updateUserManagement(userId, params){
        
        return this.client.exec(`/user-management/users/${userId}`, 'PATCH', params);
    }
    massiveAddIntegrationProfile(params = {}) {
        return this.client.exec(`/v2/admin-mod/profile/type`, 'POST', params, true)
    }
    massiveRemoveIntegrationProfile(params = {}) {
        return this.client.exec(`/v2/admin-mod/profile/type/remove`, 'POST', params, true)
    }
    getDocumentsCounts(userId:string) {
        return this.client.exec(`/user-management/users/documents-count/${userId}`, 'GET');
    }

    getSignatureReminders() {
        return this.client.exec('/scheduler/signatureReminders', 'GET');
    }

    sendSignatureReminders() {
        return this.client.exec('/scheduler/signatureReminders', 'POST', {});
    }
}
